import firebaseAdmin from "../firebase/firebase-controller";
import firebaseDevice from "../firebase/firebase-device";

const curPackage = firebaseAdmin.ref().child("CurrentPackage");

const deviceControl = firebaseDevice.ref("/devices");

class ControlsDataService {
  updateTitle = (text: string) => {
    firebaseDevice.ref("/display").child("line1").set(text);
  };
  updateText = (text: string) => {
    firebaseDevice.ref("/display").child("line2").set(text);
  };

  updateTone = (text: string, deviceId: string) => {
    const toneId = parseInt(text);
    firebaseDevice.ref("/devices").child(deviceId).child("tone").set(toneId);
  };

  updateDeviceStatus = (on: boolean, deviceId: string) => {
    firebaseDevice.ref("/devices").child(deviceId).child("on").set(on);
  };

  updatePedido = (text: string, deviceId: string) => {
    firebaseDevice.ref("/devices").child(deviceId).child("turn").set(text);
  };

  getPedido = (deviceId: string, callback: any) => {
    return deviceControl
      .child(deviceId)
      .get()
      .then((snap) => {
        if (snap.exists()) {
          callback(snap.val());
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  getCurPackage = (callback: any) => {
    return curPackage
      .get()
      .then((snap) => {
        if (snap.exists()) {
          callback(snap.val());
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  regToChangePackage = (callback: any) => {
    curPackage.on("value", (snap) => {
      callback(snap.val());
    });
  };

  regToChangeDeviceAdded = (callback: any) => {
    deviceControl.on("child_added", (snap) => {
      callback(snap.val());
    });
  };
  regToChangeDeviceChanged = (callback: any) => {
    deviceControl.on("child_changed", (snap) => {
      callback(snap.val());
    });
  };
  regToChangeDeviceTurnChanged = (callback: any,deviceId:string) => {
    deviceControl.child(deviceId).child("turn").on("value", (snap) => {
      callback(snap.val());
    });
  };
}

export default new ControlsDataService();
